import { render, staticRenderFns } from "./DefaultCheckbox.vue?vue&type=template&id=e7064e50&"
import script from "./DefaultCheckbox.vue?vue&type=script&lang=js&"
export * from "./DefaultCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports